<!-- container size -->
<div
    class="lg:inner-page-wrapper flex flex-col gap-x-24 md:grid md:grid-cols-2 md:py-24 lg:pt-40 lg:pb-[80px] xl:flex xl:flex-row xl:items-center xl:gap-x-56"
>
    <div class="relative h-full grow xl:max-w-[474px]">
        <ui-m000-c010-image
            class="block h-full"
            [image]="{
                image: image().url,
                desktop: { width: 474, height: 474 },
                tablet: { width: 488, height: 540 },
                mobile: { width: 767, height: 767 },
            }"
            [priority]="isFirstView()"
            [alt]="image().alt || (imageCaption() ?? text())"
            classList="h-full w-full aspect-square object-cover"
            cover
            highRes
        />
        @if (externalLink() && externalLinkText()) {
            <a
                ui-m010-c025-icon-link-external
                class="absolute bottom-0 left-0 hidden p-8 md:block"
                [hyundaiRouterLink]="externalLink()"
                white
            >
                {{ externalLinkText() }}
            </a>
        }
        @if (imageCaption(); as caption) {
            @let captionF = caption | footnotes;
            <p class="text-14 text-grey-400 mt-8 px-24 leading-21 lg:px-0" [innerHTML]="captionF()"></p>
        }
    </div>

    <div class="flex flex-col items-start justify-center px-24 py-40 md:p-0 xl:max-w-[686px]">
        <div class="font-headline text-24 md:text-34 leading-28 font-medium text-black md:leading-41">
            <ng-content select="[headline]" />
        </div>
        @let textFootnotes = text() | footnotes;
        <p class="text-16 mt-12 leading-27 text-black" [innerHTML]="textFootnotes()"></p>

        @if (!disableEnvkv() && envkv(); as data) {
            @let envkvWithFootnote = data | footnotes;
            <div
                class="border-grey-200 my-12 w-full border-y-1 py-[28px] md:my-8 md:py-16"
                [innerHTML]="envkvWithFootnote()"
            ></div>
        }

        @if (shortInfos(); as data) {
            @if (data.length > 0) {
                <div
                    class="border-grey-200 flex w-full gap-16 border-b-1 pb-12 md:flex-col md:gap-x-40 md:pb-8 lg:flex-row"
                >
                    @for (item of data; track $index) {
                        <div class="lg:max-w-[200px]">
                            <div class="flex items-end md:mb-12">
                                <span
                                    class="font-headline text-50 mr-4 leading-58 font-medium text-black md:text-[74px] md:leading-78"
                                >
                                    {{ item.value }}
                                </span>
                                <span
                                    class="font-headline text-18 md:text-20 mb-6 inline-block leading-27 md:mb-8 md:leading-30"
                                >
                                    {{ item.unit }}
                                </span>
                            </div>
                            <p class="text-14 md:text-16 leading-21 text-black md:leading-27">{{ item.label }}</p>
                        </div>
                    }
                </div>
            }
        }
        <a
            class="button-primary mt-24 md:mt-16 lg:w-max"
            [hyundaiRouterLink]="link()"
            [trackingElTarget]="link()"
            tracking
            trackingElLabel="Test Drive"
            trackingElType="button"
            trackingElEvent="engagement_click"
        >
            {{ linkText() }}
        </a>

        @if (externalLink(); as link) {
            <a ui-m010-c025-icon-link-external class="mt-24 block md:hidden" [hyundaiRouterLink]="link">
                {{ link }}
            </a>
        }
    </div>
</div>
